import { render, staticRenderFns } from "./LiteratureHome.vue?vue&type=template&id=884c68e8&scoped=true&"
import script from "./LiteratureHome.vue?vue&type=script&lang=js&"
export * from "./LiteratureHome.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureHome.vue?vue&type=style&index=0&id=884c68e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884c68e8",
  null
  
)

export default component.exports